import { getLayerIdFromIdPath } from '@Map/utils';
import type { ConfigLayerInternal } from '@Map/types';

/**
 * Derives the theme edit to accumulate when a layer's visibility is toggled
 * from the layer panel.
 *
 * Visibility toggles otherwise only reach `ConfigAdaptor`'s edit store (for the
 * live display) and never the theme's `pendingEdits`, which is what `saveTheme`
 * persists — so a freshly toggled layer (e.g. an individual rehab action) is
 * dropped on save and reappears after reload.
 *
 * The returned `edit` carries `id` because `ThemeService.processBody` persists
 * only the edit *value* (it discards the pendingEdits map key); without `id` the
 * saved layer cannot be re-keyed on reload and the visibility is lost.
 *
 * Returns `null` when the path has no resolvable leaf id.
 */
export function visibilityThemeEdit(
	layerPath: string,
	state: boolean,
): { id: string; edit: Partial<ConfigLayerInternal> } | null {
	const id = getLayerIdFromIdPath(layerPath);
	if (!id) return null;
	return { id, edit: { id, visible: state } };
}
